module.exports = __webpack_public_path__ + "img/dbg_logo241113_large.b2030114.svg";